import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0997ac35&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0997ac35&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0997ac35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0997ac35')) {
      api.createRecord('0997ac35', component.options)
    } else {
      api.reload('0997ac35', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0997ac35&scoped=true", function () {
      api.rerender('0997ac35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/editMuchCourse/index.vue"
export default component.exports